<template>
    <div v-if="inventoryRefreshChain && inventoryRefreshChain.hasOwnProperty('state')"
         class="card card-body bg-light-info text-info d-flex flex-row pb-4">
        <div v-if="!isCompleted">
            <Spinner class="d-inline-block"
                     :size="38"
                     :line-size="8"
                     :speed="1.6"
                     line-fg-color="#4fa0d7"
                     line-bg-color="#daebf7"
            />
        </div>
        <div class="ml-5">
            <div>
                <b>{{ __('product.refresh_progress.amazon_start') }}</b>
                <i v-if="firstStepComplete" class="fas fa-check-circle ml-1"/>
            </div>
            <div v-if="firstStepComplete">
                <b>{{ __('product.refresh_progress.ean') }}</b>
                <i v-if="secondStepComplete" class="fas fa-check-circle ml-1"/>
            </div>
            <div v-if="secondStepComplete">
                <b>{{ __('product.refresh_progress.inventory') }}</b>
                <i v-if="isCompleted" class="fas fa-check-circle ml-1"/>
            </div>
            <p v-if="isCompleted">
                {{ __('product.refresh_progress.amazon_done') }}
            </p>
            <p v-else>
                {{ __('product.refresh_progress.in_progress') }}
            </p>
        </div>
    </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';

export default {
    components: {Spinner},

    props: {
        storeUuid: String,
        initRefreshChain: {
            type: Object,
            default() {
                return {};
            },
        },
    },

    data() {
        return {
            inventoryRefreshChain: this.initRefreshChain,
        };
    },

    mounted() {
        //states: 'loading_catalogue' -> 'loading_identifiers' -> 'exporting_to_dl' -> 'done'

        window.Echo.private('inventory-refresh-chain.' + this.storeUuid).
            listen('.updated', this.updateInventoryRefreshChain);
    },

    methods: {
        updateInventoryRefreshChain(refreshChain) {
            console.log('inventory chain updated', refreshChain);
            if (refreshChain.integration === this.selectedChannel) {
                this.inventoryRefreshChain = refreshChain;
            }
        },
    },

    computed: {
        firstStepComplete() {
            return this.inventoryRefreshChain.state === 'loading_identifiers' || this.inventoryRefreshChain.state ===
                'exporting_to_dl' || this.inventoryRefreshChain.state === 'done';
        },

        secondStepComplete() {
            return this.inventoryRefreshChain.state === 'exporting_to_dl' || this.inventoryRefreshChain.state ===
                'done';
        },

        isCompleted() {
            return this.inventoryRefreshChain.state === 'done';
        },
    },
};
</script>
